import { useQuery } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import { UAParser } from 'ua-parser-js';
import { Monitor, Smartphone } from 'lucide-react';
import dayjs from '@/lib/dayjs';
import * as schema from '@/db/schema';

export default function AccountActivityScreen() {
  const { data } =
    useQuery<(typeof schema.user_activities.$inferSelect)[]>('user_activities', {
      showLoading: true,
    });

  if (!data) return null;

  return (
    <div className="flex flex-col items-center justify-start w-full h-full gap-5 py-3 px-5">
      <div className="v-stack w-full card">
        <div className="h-stack w-full pb-2 !justify-between">
          <Typography
            i18n="account_activity.device_date"
            size="2"
            color="#777777"
          />
          <Typography i18n="account_activity.ip" size="2" color="#777777" />
        </div>
        {data.map(({ id, created_at, ip, user_agent }) => {
          const { device, os } = UAParser(user_agent);

          return (
            <div
              key={id}
              className="h-stack w-full gap-2 px-1 py-1.5 cursor-pointer"
            >
              {device.type === 'mobile' ? (
                <Smartphone className="w-6 h-6 min-w-6" />
              ) : (
                <Monitor className="w-6 h-6 min-w-6" />
              )}
              <div className="v-stack w-full !items-start">
                <Typography size="3" weight={500}>
                  {os.name}
                </Typography>
                <Typography size="1" color="#777777">
                  {dayjs(created_at).format('YYYY/MM/DD HH:mm')}
                </Typography>
              </div>
              <div className="v-stack w-full ml-auto !items-end">
                <Typography size="2" color="#777777">
                  {ip}
                </Typography>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
